import supabase from 'modules/core/supabase/supabase';
import getGameInfo from '../repositories/match-by-id';
import { updateFoulPeriods } from './update-foul-periods';
import { updateMembersStats } from './update-members-stats';

export async function getMappedGameInfo(matchId: number) {
  const gameInfo = await getGameInfo(matchId);
  if (!gameInfo) return undefined;

  // Журнал матча только читаем — его ведёт мобильное приложение. Раньше здесь настройки
  // соревнования уезжали в `matchChronology.init`, чтобы оверлей мог завести строку сам.
  if (gameInfo.match?.id) {
    const events = await supabase.matchChronology.getRow(gameInfo.match.id);
    if (events) {
      await updateMembersStats(gameInfo, events);
      await updateFoulPeriods(gameInfo, events);
    }
  }

  return gameInfo;
}
